module.exports = __webpack_public_path__ + "img/DSC_0307.825be993.jpg";